import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import CommonWebinarSessionDateTime from 'common/components/entities/WebinarSessionDateTime/WebinarSessionDateTimeNew'
import WebinarSessionDateTimeInterface from 'common/types/entities/WebinarSessionDateTimeInterface'
import React from 'react'
import { EntityProps } from '../../../types'

function WebinarSessionDateTime({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<WebinarSessionDateTimeInterface>) {
  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonWebinarSessionDateTime
        attrId={entity.htmlAttrId}
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
        border={entity.border}
        mobileBorder={entity.mobileBorder}
        backgroundColor={entity.backgroundColor}
        mobileBackgroundColor={entity.mobileBackgroundColor}
        color={entity.color}
        mobileColor={entity.mobileColor}
        fontSize={entity.fontSize}
        iconFontSize={entity.iconFontSize}
        mobileFontSize={entity.mobileFontSize}
        mobileIconFontSize={entity.mobileIconFontSize}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
        fontFamily={entity.fontFamily}
        fontWeight={entity.fontWeight}
        fontStyle={entity.fontStyle}
        mobileFontFamily={entity.mobileFontFamily}
        mobileFontWeight={entity.mobileFontWeight}
        mobileFontStyle={entity.mobileFontStyle}
      />
    </BaseEntityNew>
  )
}

export default WebinarSessionDateTime
